import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { userInfoCacheKey } from "./constants";
import type {
  PutUserInfoUpdateSubscriptionGroupStatusParams,
  PutUserInfoUpdateSubscriptionGroupStatusResponse,
} from "./types";

export const putUserInfoUpdateSubscriptionGroupStatus = reactQueryMutationAdapter(
  [userInfoCacheKey],
  ({
    locale,
    userId,
    ...body
  }: PutUserInfoUpdateSubscriptionGroupStatusParams): Promise<PutUserInfoUpdateSubscriptionGroupStatusResponse> => {
    if (locale) {
      return fetch(`/apps/user_info/${userId}/update_subscription_group_status?locale=${locale}`, "PUT", body);
    }

    return fetch(`/apps/user_info/${userId}/update_subscription_group_status`, "PUT", body);
  }
);
